import { Link } from "react-router-dom";

export function BooksInProducts() {
  return <section className="notice" aria-label="Manage books">
    <h2>Books are managed in Products</h2>
    <p>Edit each book’s description, images, price and stock together. Publishing a product adds it to the website’s bookshelf.</p>
    <Link className="btn btn--primary" to="/products">Manage books in Products</Link>
  </section>;
}
